function generatePageSpecificRows({ featuredProjs, rowPage }) {
  const rowsObj = {
    hasInfo: false,
    name: [],
    image: [],
    type: [],
    pageLink: [],
    pageLinkDesc: [],
    winner: [],
  }
  switch (rowPage) {
    case "commercial":
      rowsObj.hasInfo = true
      featuredProjs.forEach(item => {
        const {
          commercial_featured_projects_name,
          commercial_featured_projects_image,
          commercial_featured_projects_type,
          commercial_featured_projects_page_link,
          commercial_featured_projects_page_link_description,
        } = item
        rowsObj.name.push(commercial_featured_projects_name)
        rowsObj.image.push(commercial_featured_projects_image)
        rowsObj.type.push(commercial_featured_projects_type)
        rowsObj.pageLink.push(commercial_featured_projects_page_link)
        rowsObj.pageLinkDesc.push(commercial_featured_projects_page_link_description)
      })
      break

    case "styling":
      rowsObj.hasInfo = true
      featuredProjs.forEach(item => {
        const {
          styling_featured_projects_name,
          styling_featured_projects_image,
          styling_featured_projects_type,
          styling_featured_projects_page_link,
          styling_featured_projects_page_link_description,
        } = item
        rowsObj.name.push(styling_featured_projects_name)
        rowsObj.image.push(styling_featured_projects_image)
        rowsObj.type.push(styling_featured_projects_type)
        rowsObj.pageLink.push(styling_featured_projects_page_link)
        rowsObj.pageLinkDesc.push(styling_featured_projects_page_link_description)
      })
      break

    case "residential":
      rowsObj.hasInfo = true
      featuredProjs.forEach(item => {
        const {
          residential_featured_projects_name,
          residential_featured_projects_image,
          residential_featured_projects_type,
          residential_featured_projects_page_link,
          residential_featured_projects_page_link_description,
        } = item
        rowsObj.name.push(residential_featured_projects_name)
        rowsObj.image.push(residential_featured_projects_image)
        rowsObj.type.push(residential_featured_projects_type)
        rowsObj.pageLink.push(residential_featured_projects_page_link)
        rowsObj.pageLinkDesc.push(residential_featured_projects_page_link_description)
      })
      break

    case "portfolio":
      rowsObj.hasInfo = true
      featuredProjs.forEach(item => {
        const { node } = item
        rowsObj.name.push(node.title)
        rowsObj.image.push(node.acf.projects_project_details_image)
        rowsObj.type.push(node.acf.projects_project_details_description)
        rowsObj.pageLink.push(node.link)
        rowsObj.winner.push(node.acf.projects_project_details_winner)
      })
      break

    default:
      rowsObj.hasInfo = false
      rowsObj.name.push("")
      rowsObj.image.push({
        localFile: {
          childImageSharp: {
            fluid: {
              src: "",
            },
          },
        },
      })
      rowsObj.type.push("")
      rowsObj.pageLink.push("")
      rowsObj.pageLinkDesc.push("")
      break
  }
  return rowsObj
}

export { generatePageSpecificRows }
